import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { VendaFormaPag } from '../models/venda-forma-pag';
import swal from 'sweetalert2';
import { CadastrarMultiFormaPagamentoModalComponent } from '../modals/multi-forma-pagamento-modal/cadastrar-multi-forma-pagamento-modal/cadastrar-multi-forma-pagamento-modal.component';
import { MatDialog } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { GlobalService } from '../services/global.service';
import { TipoVendaFormaPag } from '../models/enum';
import { CadastrarMultiFormaPagamentoComponent } from './cadastrar-multi-forma-pagamento/cadastrar-multi-forma-pagamento.component';

declare const $: any;

@Component({
  selector: 'app-multi-forma-pagamento',
  templateUrl: './multi-forma-pagamento.component.html',
  styleUrls: ['./multi-forma-pagamento.component.scss']
})
export class MultiFormaPagamentoComponent implements OnInit, OnChanges {
  @ViewChildren(CadastrarMultiFormaPagamentoComponent)
  componentesFormaPagamento: QueryList<CadastrarMultiFormaPagamentoComponent>;

  @Input() formasPagamentoMulti: VendaFormaPag[] = [];
  @Input() valorSubTotalPedido = 0;
  valorFormasPagamento = 0;
  @Input() editavel = true;
  @Input() pCentroDistribuicao = false;
  @Input() pMultiFornecedor = false;
  @Input() idCD;
  @Input() valorFinal;
  @Input() podeMulti = false;
  @Input() qtdMaxMulti = 0;
  @Input() repasse = null;

  @Output() aoAlterar = new EventEmitter<boolean>();

  alterou = false;
  public MASKS = MASKS;

  valorRestante = 0;

  suporte = false;

  constructor(
    private dialog: MatDialog,
    private globalService: GlobalService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.formasPagamentoMulti &&
      JSON.stringify(changes.formasPagamentoMulti.currentValue) !==
        JSON.stringify(changes.formasPagamentoMulti.previousValue)
    ) {
      this.atualizarValorFormas();
      this.calcularValorRestante();
    }
  }

  async ngOnInit() {
    this.suporte = await this.globalService.suporte();
    this.atualizarValorFormas();
  }

  trackByItemId(index: number, item: VendaFormaPag): number {
    return item.id;
  }

  novaFormaPagamento() {
    this.calcularValorRestante();

    if (this.valorRestante === 0 || (this.qtdMaxMulti > 0 && this.formasPagamentoMulti.length === this.qtdMaxMulti)) {
      return;
    }

    const novaForma = new VendaFormaPag();
    novaForma.valor = this.valorRestante;
    novaForma.tipo = TipoVendaFormaPag.Variavel;

    this.formasPagamentoMulti.push(novaForma);

    return;

    // const novaForma = new VendaFormaPag();
    // novaForma.valor = this.valorRestante;

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarMultiFormaPagamentoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card',
      data: {
        forma: novaForma,
        valorSubTotalPedido: this.valorSubTotalPedido,
        pCentroDistribuicao: this.pCentroDistribuicao,
        pMultiFornecedor: this.pMultiFornecedor,
        idCD: this.idCD,
        valorMaximo: this.calcularValorRestante()
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.alterou = true;

      res.valor = Number(res.valor);
      this.formasPagamentoMulti.push(res);
      this.atualizarValorFormas();

      this.aoAlterar.emit(true);
    });
  }

  atualizar() {
    this.atualizarValorFormas();
    this.calcularValorRestante();
    this.alterou = true;
    this.aoAlterar.emit(true);
  }

  limpar() {
    this.formasPagamentoMulti = [];
    this.novaFormaPagamento();
    this.atualizar();
  }

  async salvarTodos() {
    for (const componente of this.componentesFormaPagamento.toArray()) {
      await componente.salvar(false);
    }

    // const resultados = await Promise.all(
    //   this.componentesFormaPagamento.toArray().map((componente) => componente.salvar(false))
    // );

    // const todosValidos = resultados.every((valido) => valido);

    // if (todosValidos) {
    //   this.atualizar();
    // }

    // return todosValidos;
  }

  recarregarFormasPagamentoPrimeiraForma(): void {
    const primeiroComponente = this.componentesFormaPagamento && this.componentesFormaPagamento.first;

    if (primeiroComponente) {
      primeiroComponente.recarregarFormasDePagamento();
    }
  }

  onObterValorRestante(event: { forma: VendaFormaPag; resolve: (valor: number) => void }) {
    const valorFormasPagamento = this.formasPagamentoMulti
      .filter((p) => p !== event.forma)
      .reduce((acc, curr) => (acc += Number(curr.valor)), 0);
    const valorRestante = Number(
      (this.valorSubTotalPedido - valorFormasPagamento > 0
        ? this.valorSubTotalPedido - valorFormasPagamento
        : 0
      ).toFixed(2)
    );
    event.resolve(valorRestante);
  }

  editarFormaPagamento(forma: VendaFormaPag) {
    const formaParaEditar = Object.assign({}, forma);
    formaParaEditar.valor = Number(formaParaEditar.valor);
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarMultiFormaPagamentoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        forma: formaParaEditar,
        pCentroDistribuicao: this.pCentroDistribuicao,
        pMultiFornecedor: this.pMultiFornecedor,
        idCD: this.idCD
        // valorMaximo: Number((this.calcularValorRestante() + formaParaEditar.valor).toFixed(2))
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res: VendaFormaPag) => {
      if (!res) return;

      forma.descricaoCondPag = res.descricaoCondPag;
      forma.descricaoFormaPag = res.descricaoFormaPag;
      forma.idCondPag = res.idCondPag;
      forma.idFormaPag = res.idFormaPag;
      forma.idCupom = res.idCupom;
      forma.valor = Number(res.valor);
      forma.tipo = res.tipo;
      forma.rateio = res.rateio;
      forma.valorRateio = res.valorRateio;
      forma.taxa = res.taxa;
      forma.valorTaxa = res.valorTaxa;
      forma.total = res.total;
      this.alterou = true;

      this.atualizarValorFormas();

      this.aoAlterar.emit(true);
    });
  }

  excluirFormaPagamento(item: VendaFormaPag) {
    swal({
      title: 'Deseja realmente Excluir a Forma de Pagamento ?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.formasPagamentoMulti.splice(this.formasPagamentoMulti.indexOf(item), 1);
        this.atualizarValorFormas();
        this.alterou = true;

        this.aoAlterar.emit(true);
      }
    });
  }

  atualizarValorFormas() {
    this.valorFormasPagamento = this.formasPagamentoMulti.reduce((acc, curr) => (acc += Number(curr.valor)), 0);
  }

  ordena(campo) {
    return false;
  }

  calcularValorRestante() {
    this.valorRestante = Number(
      (this.valorSubTotalPedido - this.valorFormasPagamento > 0
        ? this.valorSubTotalPedido - this.valorFormasPagamento
        : 0
      ).toFixed(2)
    );
  }

  calcularTotalFormas() {
    if (
      this.formasPagamentoMulti === null ||
      this.formasPagamentoMulti === undefined ||
      this.formasPagamentoMulti.length === 0
    ) {
      return 0;
    } else {
      return Number(
        this.formasPagamentoMulti
          .reduce((accumulator, currentValue) => accumulator + Number(currentValue.total), 0)
          .toFixed(2)
      );
    }
  }

  validar() {
    this.calcularValorRestante();
    return (
      this.valorRestante === 0 &&
      this.calcularTotalFormas() === this.valorFinal &&
      !this.formasPagamentoMulti.some(
        (p) => p.idFormaPag == null || p.idFormaPag == undefined || p.idCondPag == null || p.idCondPag == undefined
      )
    );
  }
}
